import { StorageInstallationStatementModel } from '../models'

export const DEFAULT_STORAGE_DATA: Readonly<StorageInstallationStatementModel> = {
  installationStatementId: null,
  connectionType: null,
  weatherConditions: null,
  netConfiguration: null,
  wallMounted: false,
  installationType: null,
  applicationArea: null,
  emergencyOption: false,
  distanceTop: null,
  distanceFront: null,
  distanceLeft: null,
  distanceRight: null,
  temperature: null,
  showEdisonWallboxStep: false,
  hasBiDiWallbox: false,
}
